import { Card, LabelValueRow, Tabs } from 'components/core-v2'

export const Loading = () => (
  <Tabs.Panel value="terms">
    <Card.Wrapper>
      <LabelValueRow isLoading label="Trade name" />
      <LabelValueRow isLoading label="Initial investment" />
      <LabelValueRow isLoading label="Start date" />
    </Card.Wrapper>
  </Tabs.Panel>
)
